import type { Action } from 'state/actions';

import type { OrdersBasketWorkspaceMetaState } from './meta.model';
import { initialOrdersBasketWorkspaceMetaState } from './meta.model';

export function ordersBasketWorkspaceMetaReducer(
  state: OrdersBasketWorkspaceMetaState = initialOrdersBasketWorkspaceMetaState,
  action: Action,
): OrdersBasketWorkspaceMetaState {
  switch (action.type) {
    case 'WORKSPACE_PERSISTED_TABS_APPLIED':
      return action.workspace === 'ordersBasket' ? { ...state, workspaceTabsFetched: true } : state;
    case 'ORDERS_BASKET_TAB_CONTENT_ALL_FETCHED':
      return { ...state, workspaceTabContentAllFetched: true };
    default:
      return state;
  }
}
